"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.size = exports.rotate = exports.rgbaWhite = exports.rgbaBlack = exports.px = exports.pseudoBlock = exports.overlay = exports.locales = exports.fontStack = exports.fontSmoothing = exports.fieldTypeIsValid = exports.fadeIn = exports.currencySymbol = exports.color = exports.absoluteCenter = exports.SOLID_BORDER = exports.DASHED_BORDER = exports.BORDER = exports.SELECT_MENU_MAX_HEIGHT = exports.TIME_FORMAT = exports.LINE_HEIGHT = exports.INLINE_SPACING = exports.FONT_FALLBACK = exports.FONT_2 = exports.FONT_1 = exports.FIELD_WIDTH = exports.DATE_FORMAT = exports.COLOR = exports.BORDER_WIDTH = exports.BORDER_STYLE = exports.BORDER_RADIUS = exports.BORDER_COLOR = exports.ALIGN_ITEMS = exports.DEFAULT_BORDER = exports.DEFAULT_SELECT_MENU_MAX_HEIGHT = exports.DEFAULT_TIME_FORMAT = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_LINE_HEIGHT = exports.DEFAULT_INLINE_SPACING = exports.DEFAULT_FONT_FALLBACK = exports.DEFAULT_FONT_2 = exports.DEFAULT_FONT_1 = exports.DEFAULT_FIELD_WIDTH = exports.DEFAULT_DATE_FORMAT = exports.DEFAULT_BORDER_WIDTH = exports.DEFAULT_BORDER_STYLE = exports.DEFAULT_BORDER_RADIUS = exports.DEFAULT_BORDER_COLOR = exports.DEFAULT_ALIGN_ITEMS = exports.TEXT_AREA_FIELD = exports.TEXT_FIELD = exports.SELECT_FIELD = exports.NUMBER_FIELD = exports.DATE_TIME_FIELD = exports.FOR_RETINA = exports.FOR_DESKTOP = exports.FOR_TABLET = exports.FOR_MOBILE = exports.TABLET_WIDTH = exports.MOBILE_WIDTH = exports.MIN_DEVICE_PIXEL_RATIO = exports.ANIMATION_SPEED_SLOWEST = exports.ANIMATION_SPEED_SLOWER = exports.ANIMATION_SPEED_SLOW = exports.ANIMATION_SPEED_MEDIUM = exports.ANIMATION_SPEED_FAST = exports.ANIMATION_SPEED_FASTER = exports.ANIMATION_SPEED_FASTEST = exports.FONT_2_WEIGHT_2 = exports.FONT_2_WEIGHT_1 = exports.FONT_WEIGHT_5 = exports.FONT_WEIGHT_4 = exports.FONT_WEIGHT_3 = exports.FONT_WEIGHT_2 = exports.FONT_WEIGHT_1 = exports.WHITE = exports.LIGHTEST_GRAY = exports.LIGHTER_GRAY = exports.LIGHT_GRAY = exports.GRAY = exports.DARK_GRAY = exports.DARKER_GRAY = exports.DARKEST_GRAY = exports.BLACK = exports.PINK = exports.PURPLE = exports.BLUE = exports.GREEN = exports.YELLOW = exports.ORANGE = exports.RED = exports.SMALLEST = exports.SMALLER = exports.SMALL = exports.MEDIUM = exports.LARGE = exports.LARGER = exports.LARGEST = undefined;

var _mixins = require("./mixins");

var _color = require("./color");

var _color2 = _interopRequireDefault(_color);

var _currencySymbol = require("./currencySymbol");

var _currencySymbol2 = _interopRequireDefault(_currencySymbol);

var _fieldTypeIsValid = require("./fieldTypeIsValid");

var _fieldTypeIsValid2 = _interopRequireDefault(_fieldTypeIsValid);

var _fontStack = require("./fontStack");

var _fontStack2 = _interopRequireDefault(_fontStack);

var _locales = require("./locales");

var _locales2 = _interopRequireDefault(_locales);

var _px = require("./px");

var _px2 = _interopRequireDefault(_px);

var _size = require("./size");

var _size2 = _interopRequireDefault(_size);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} //// GLOBALS
// size


var LARGEST = exports.LARGEST = 94;
var LARGER = exports.LARGER = 76;
var LARGE = exports.LARGE = 60;
var MEDIUM = exports.MEDIUM = 46;
var SMALL = exports.SMALL = 34;
var SMALLER = exports.SMALLER = 24;
var SMALLEST = exports.SMALLEST = 16; // color

var RED = exports.RED = '#de4c02';
var ORANGE = exports.ORANGE = '#f39c12';
var YELLOW = exports.YELLOW = '#f1c40f';
var GREEN = exports.GREEN = '#27ae60';
var BLUE = exports.BLUE = '#3498db';
var PURPLE = exports.PURPLE = '#9a59b8';
var PINK = exports.PINK = '#de659c'; // grayscale

var BLACK = exports.BLACK = '#0a0b0c';
var DARKEST_GRAY = exports.DARKEST_GRAY = '#2a2d2f';
var DARKER_GRAY = exports.DARKER_GRAY = '#35393d';
var DARK_GRAY = exports.DARK_GRAY = '#4c4e51';
var GRAY = exports.GRAY = '#777879';
var LIGHT_GRAY = exports.LIGHT_GRAY = '#999b9c';
var LIGHTER_GRAY = exports.LIGHTER_GRAY = '#bbbdbf';
var LIGHTEST_GRAY = exports.LIGHTEST_GRAY = '#d5d7d8';
var WHITE = exports.WHITE = '#ffffff'; // font weight

var FONT_WEIGHT_1 = exports.FONT_WEIGHT_1 = 300;
var FONT_WEIGHT_2 = exports.FONT_WEIGHT_2 = 400;
var FONT_WEIGHT_3 = exports.FONT_WEIGHT_3 = 500;
var FONT_WEIGHT_4 = exports.FONT_WEIGHT_4 = 700;
var FONT_WEIGHT_5 = exports.FONT_WEIGHT_5 = 800;
var FONT_2_WEIGHT_1 = exports.FONT_2_WEIGHT_1 = 300;
var FONT_2_WEIGHT_2 = exports.FONT_2_WEIGHT_2 = 400; // animation speed

var ANIMATION_SPEED_FASTEST = exports.ANIMATION_SPEED_FASTEST = '.1s';
var ANIMATION_SPEED_FASTER = exports.ANIMATION_SPEED_FASTER = '.125s';
var ANIMATION_SPEED_FAST = exports.ANIMATION_SPEED_FAST = '.15s';
var ANIMATION_SPEED_MEDIUM = exports.ANIMATION_SPEED_MEDIUM = '.2s';
var ANIMATION_SPEED_SLOW = exports.ANIMATION_SPEED_SLOW = '.25s';
var ANIMATION_SPEED_SLOWER = exports.ANIMATION_SPEED_SLOWER = '.375s';
var ANIMATION_SPEED_SLOWEST = exports.ANIMATION_SPEED_SLOWEST = '.5s'; // border
// media queries

var MIN_DEVICE_PIXEL_RATIO = exports.MIN_DEVICE_PIXEL_RATIO = 2;
var MOBILE_WIDTH = exports.MOBILE_WIDTH = 320;
var TABLET_WIDTH = exports.TABLET_WIDTH = 736;
var FOR_MOBILE = exports.FOR_MOBILE = "@media (max-width: " + MOBILE_WIDTH + "px)";
var FOR_TABLET = exports.FOR_TABLET = "@media (min-width: " + (MOBILE_WIDTH + 1) + "px) and (max-width: " + TABLET_WIDTH + "px)";
var FOR_DESKTOP = exports.FOR_DESKTOP = "@media (min-width: " + (TABLET_WIDTH + 1) + "px)";
var FOR_RETINA = exports.FOR_RETINA = "@media (-webkit-min-device-pixel-ratio: " + MIN_DEVICE_PIXEL_RATIO + ")"; // field types

var DATE_TIME_FIELD = exports.DATE_TIME_FIELD = 'dateTime';
var NUMBER_FIELD = exports.NUMBER_FIELD = 'number';
var SELECT_FIELD = exports.SELECT_FIELD = 'select';
var TEXT_FIELD = exports.TEXT_FIELD = 'text';
var TEXT_AREA_FIELD = exports.TEXT_AREA_FIELD = 'textArea'; //// DEFAULTS

var DEFAULT_ALIGN_ITEMS = exports.DEFAULT_ALIGN_ITEMS = 'center';
var DEFAULT_BORDER_COLOR = exports.DEFAULT_BORDER_COLOR = 'transparent';
var DEFAULT_BORDER_RADIUS = exports.DEFAULT_BORDER_RADIUS = '1px';
var DEFAULT_BORDER_STYLE = exports.DEFAULT_BORDER_STYLE = 'solid';
var DEFAULT_BORDER_WIDTH = exports.DEFAULT_BORDER_WIDTH = '1px';
var DEFAULT_DATE_FORMAT = exports.DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
var DEFAULT_FIELD_WIDTH = exports.DEFAULT_FIELD_WIDTH = '200px';
var DEFAULT_FONT_1 = exports.DEFAULT_FONT_1 = 'effra';
var DEFAULT_FONT_2 = exports.DEFAULT_FONT_2 = 'din-condensed';
var DEFAULT_FONT_FALLBACK = exports.DEFAULT_FONT_FALLBACK = 'Avenir, Open Sans, Helvetica Neue, Calibri, Arial, sans-serif';
var DEFAULT_INLINE_SPACING = exports.DEFAULT_INLINE_SPACING = SMALLER;
var DEFAULT_LINE_HEIGHT = exports.DEFAULT_LINE_HEIGHT = 1.1;
var DEFAULT_TEXT_COLOR = exports.DEFAULT_TEXT_COLOR = DARK_GRAY;
var DEFAULT_TIME_FORMAT = exports.DEFAULT_TIME_FORMAT = 'h:mm a';
var DEFAULT_SELECT_MENU_MAX_HEIGHT = exports.DEFAULT_SELECT_MENU_MAX_HEIGHT = '12em';
var DEFAULT_BORDER = exports.DEFAULT_BORDER = DEFAULT_BORDER_WIDTH + " " + DEFAULT_BORDER_STYLE + " " + DEFAULT_BORDER_COLOR; // get rid of these where they're used

var ALIGN_ITEMS = exports.ALIGN_ITEMS = DEFAULT_ALIGN_ITEMS;
var BORDER_COLOR = exports.BORDER_COLOR = DEFAULT_BORDER_COLOR;
var BORDER_RADIUS = exports.BORDER_RADIUS = DEFAULT_BORDER_RADIUS;
var BORDER_STYLE = exports.BORDER_STYLE = DEFAULT_BORDER_STYLE;
var BORDER_WIDTH = exports.BORDER_WIDTH = DEFAULT_BORDER_WIDTH;
var COLOR = exports.COLOR = DEFAULT_TEXT_COLOR;
var DATE_FORMAT = exports.DATE_FORMAT = DEFAULT_DATE_FORMAT;
var FIELD_WIDTH = exports.FIELD_WIDTH = DEFAULT_FIELD_WIDTH;
var FONT_1 = exports.FONT_1 = DEFAULT_FONT_1;
var FONT_2 = exports.FONT_2 = DEFAULT_FONT_2;
var FONT_FALLBACK = exports.FONT_FALLBACK = DEFAULT_FONT_FALLBACK;
var INLINE_SPACING = exports.INLINE_SPACING = DEFAULT_INLINE_SPACING;
var LINE_HEIGHT = exports.LINE_HEIGHT = DEFAULT_LINE_HEIGHT;
var TIME_FORMAT = exports.TIME_FORMAT = DEFAULT_TIME_FORMAT;
var SELECT_MENU_MAX_HEIGHT = exports.SELECT_MENU_MAX_HEIGHT = DEFAULT_SELECT_MENU_MAX_HEIGHT;
var BORDER = exports.BORDER = DEFAULT_BORDER;
var DASHED_BORDER = exports.DASHED_BORDER = DEFAULT_BORDER_WIDTH + " dashed " + LIGHTER_GRAY;
var SOLID_BORDER = exports.SOLID_BORDER = DEFAULT_BORDER_WIDTH + " solid " + GRAY; //// MIXINS & UTILS

exports.absoluteCenter = _mixins.absoluteCenter;
exports.color = _color2.default;
exports.currencySymbol = _currencySymbol2.default;
exports.fadeIn = _mixins.fadeIn;
exports.fieldTypeIsValid = _fieldTypeIsValid2.default;
exports.fontSmoothing = _mixins.fontSmoothing;
exports.fontStack = _fontStack2.default;
exports.locales = _locales2.default;
exports.overlay = _mixins.overlay;
exports.pseudoBlock = _mixins.pseudoBlock;
exports.px = _px2.default;
exports.rgbaBlack = _mixins.rgbaBlack;
exports.rgbaWhite = _mixins.rgbaWhite;
exports.rotate = _mixins.rotate;
exports.size = _size2.default;